import { useState, useEffect, useRef } from "react";

// Renders a long array incrementally; reveals more as a sentinel scrolls into view.
export function useInfiniteList(items, pageSize = 50) {
  const [count, setCount] = useState(pageSize);
  const sentinelRef = useRef(null);

  useEffect(() => { setCount(pageSize); }, [items, pageSize]);

  const hasMore = count < items.length;

  useEffect(() => {
    if (!hasMore) return;
    const el = sentinelRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) setCount((c) => c + pageSize); },
      { rootMargin: "300px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [hasMore, pageSize, count]);

  return { visible: items.slice(0, count), hasMore, sentinelRef, total: items.length, shown: Math.min(count, items.length) };
}
